// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__1AOoV","rotation":"loader_rotation__a2Qf7"};